export function onReady(
  targetState: "interactive" | "complete" = "interactive"
) {
  return new Promise(resolve => {
    document.addEventListener("readystatechange", () => {
      if (document.readyState === targetState) resolve();
    });
  });
}
